import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Checkbox, ModalIsland } from '@saviynt/design-system';
import PropTypes from 'prop-types';

import { SET_IS_REASSIGN_WARN_MSG_OPENED } from '../../../redux/certdetails/types';
import { useInvertedLocalize } from '../../../utils/localization';

import { invertedMessages } from './messages';

import './CertsReassignWarnModal.css';

function CertsReassignWarnModal({
  isReassignWarnModalOpen,
  handleClose,
  handleWarnModal,
  isActionLoading,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const dispatch = useDispatch();
  const l = useInvertedLocalize(invertedMessages);

  useEffect(() => {
    setIsOpen(isReassignWarnModalOpen);
  }, [isReassignWarnModalOpen]);

  const getReassignWarnModal = () => (
    <ModalIsland
      kind='warning'
      className='CertsReassignWarnModal'
      classNames={{
        alertContentClassName: 'CertsReassignWarnModal-alertContent',
        alertBgClassName: 'CertsReassignWarnModal-alertBg',
      }}
      alertTitle={<>{l('Reassignment Can’t Be Undone')}</>}
      alertSubtitle={l(
        'When you reassign one of your certification items to another certifier, it’ll be removed from your list and can’t be retracted. Do you want to reassign this item?'
      )}
      onClose={() => {
        // close modal
        handleClose();
      }}
      isOpen={isOpen}
      primaryButton={
        <>
          <Checkbox
            className='CertsReassignWarnModal-checkbox'
            id='reassign-warning-modal-checkbox'
            name='checkbox0'
            kind='singleLine'
            dataTestId='checkbox0'
            isChecked={isChecked}
            onChange={(event) => {
              setIsChecked(event.target.checked);
              dispatch({ type: SET_IS_REASSIGN_WARN_MSG_OPENED });
            }}
            label={l('Don’t show this message again')}
            textPosition='after'
          />
          <Button
            type='button'
            kind='outlined'
            size='medium'
            isDisabled={isActionLoading}
            isLoading={isActionLoading}
            loaderText={l('Reassign')}
            onClick={(e) => {
              handleWarnModal(e, true);
            }}>
            {l('Reassign')}
          </Button>
        </>
      }
      secondaryButton={
        <Button
          type='button'
          kind='ghost'
          size='medium'
          onClick={handleClose}
          isDisabled={isActionLoading}>
          {l('Cancel')}
        </Button>
      }
    />
  );

  return <section>{getReassignWarnModal()}</section>;
}

CertsReassignWarnModal.propTypes = {
  isReassignWarnModalOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleWarnModal: PropTypes.func.isRequired,
  isActionLoading: PropTypes.bool.isRequired,
};

CertsReassignWarnModal.defaultProps = {};

export default CertsReassignWarnModal;
